/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4a1b8bcf&lang=less&scoped=true"

import exportComponent from "/opt/cicd/JobConf/hxship-sts/touristagency/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a1b8bcf"]])

export default __exports__